/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ICONS from "../../../../assets/Icons/index.js";
import PrimaryButton from "../../../../components/_utils/CommonButtons/PrimaryButton/index.jsx";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent/index.jsx";
import FormatAmount from "../../../../components/_utils/FormatAmount/FormatAmount.js";
import PaginationComponent from "../../../../components/_utils/PaginationComponent/index.jsx";
import Loader from "../../../../components/Loader/Index.jsx";
import ScheduleInternalTransactionViewAllCard from "../../../../components/Transactions/ScheduleInternalTransaction/ScheduleInternalTransactionViewAllCard/index.jsx";
import { getAllInternalAccounts } from "../../../../redux/features/accounts/internalAccount/index.js";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher.js";
import { ownerAccountsViewAll } from "../../../../redux/features/owner/ownerAllVerification/ownerAllVerification.js";
import { getAllCategories } from "../../../../redux/features/sharedResources/sharedResources.js";
import { scheduledInternalViewAll } from "../../../../redux/features/transactions/scheduleInternalTransactions/index.js";
import {
  GlobalConfiguration,
  PaginationConfiguration,
} from "../../../../utils/configurationProvider.js";
import { standardAccountNumberFormat } from "../../../../utils/standardAccountNumberFormat.js";
import useCustomSearchParams from "../../../../utils/useCustomSearchParams.js";

const ScheduleInternalTransactionViewSchedules = (props) => {
  const dispatch = useDispatch();
  const dropdownOptions = PaginationConfiguration.paginationOptions;
  const duplicateFilters = props?.duplicateFilters;

  const { searchParam, handleClearSearchParam, handleSearchParams } =
    useCustomSearchParams({
      pageno: GlobalConfiguration.lengthCheckOne,
      pagesize: dropdownOptions[0],
    });
  const ctaRef = useRef(null);
  const searchBarContainer = useRef(null);
  const searchBarRef = useRef(null);
  const scrollRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  const [isSidebarOpen] = useState(false);

  const [txnPayLoad, setTxnPayLoad] = useState({
    bankAccountName: "",
    beneAccountId: props?.internal_account_id ? props?.internal_account_id : "",
    bankAccountNo: props?.destination_account_number
      ? props?.destination_account_number
      : "",
    bankAccountIFSC: "",

    ownerAccountId: props?.owner_account_id ? props?.owner_account_id : "",
    amount: "",
    ownerbankAccountNo: props?.source_account_number
      ? props?.source_account_number
      : "",
  });

  const [hideCarousal, setHideCaroursal] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  const [FrequencyMethodfilter, setFrequencyMethodfilter] = useState(
    searchParam.get("frequency") || "",
    "",
  );
  const [isPaymentMethod, setIsPaymentMethod] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      duplicateFilters?.payment_method
      ? duplicateFilters?.payment_method
      : searchParam.get("paymentmethod") || "",
    "",
  );
  const [currentStatus, setCurrentStatus] = useState(
    props?.type === "scheduleInternalAcc"
      ? "pending"
      : searchParam.get("lifecycle") || "",
    "",
  );
  const [confidentialMethodFilter, setConfidentialMethodFilter] = useState(
    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
      duplicateFilters?.confidential_transaction ===
        "Show only confidential") ||
      (props?.isConf ?? false)
      ? "Show only confidential"
      : searchParam.get("confidential") || "",
    "",
  );

  const [txnAmountFilter, setTxnAmountFilter] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.amount
      ? props?.txnPayLoad?.amount
      : searchParam.get("amount") || "",
    "",
  );

  const [DestinationAccountName, setDestinationAccountName] = useState(
    props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.beneAccountId
      ? props?.txnPayLoad?.beneAccountId
      : props?.txnHistorytype === "Schedule_Internal_Txn" ||
          props?.type === "scheduleInternalAcc"
        ? props?.internal_account_id
        : searchParam.get("internalAcc") || "",
    "",
  );
  const [startDate, setStartDate] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDate, setEndDate] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [startDateFilter, setStartDateFilter] = useState(
    searchParam.get("startDate")
      ? new Date(searchParam.get("startDate")) || ""
      : "",
  );
  const [endDateFilter, setEndDateFilter] = useState(
    searchParam.get("endDate")
      ? new Date(searchParam.get("endDate")) || ""
      : "",
  );
  const [txnPayLoadFilter, setTxnPayLoadFilter] = useState(
    props?.source_account_number ?? "",
  );

  const [txnPayLoadAccountNameFilter, setTxnPayLoadAccountNameFilter] =
    useState(
      props?.txnHistorytype === "internalScheduleCreateTxn" &&
        props?.txnPayLoad?.ownerId
        ? props?.txnPayLoad?.ownerId
        : props?.txnHistorytype === "Schedule_Internal_Txn" &&
            props?.owner_account_id
          ? props?.owner_account_id
          : searchParam.get("sourceAcc") || "",
      "",
    );
  const [txnPayLoadDesitinationNameFilter, setTxnPayLoadDestinationNameFilter] =
    useState(props?.destination_account_number ?? "");

  const [, setAccountName] = useState(
    txnPayLoad?.bankAccountName ? txnPayLoad?.bankAccountName : "",
  );
  const [accountNumber, setAccountNumber] = useState(
    props?.txnHistorytype === "Schedule_Internal_Txn" && props?.isConf
      ? txnPayLoadFilter
      : props?.txnHistorytype === "internalScheduleCreateTxn" &&
          props?.txnPayLoad?.ownerBankAccountNo
        ? props?.txnPayLoad?.ownerBankAccountNo
        : txnPayLoad?.bankAccountNo
          ? txnPayLoad?.bankAccountNo
          : "",
  );

  const [beneAccountId] = useState(
    txnPayLoad?.beneAccountId ? txnPayLoad?.beneAccountId : null,
  );

  const [accumulatedData, setAccumulatedData] = useState([]);
  const [mainData, setMainData] = useState([]);
  const [showSearchBar, setShowSearchBar] = useState(false);
  const [showInnerSearchBar, setShowInnerSearchBar] = useState(false);
  const [active, setActive] = useState("");
  const [loadingData, setLoadingData] = useState(false);
  const [inputData, setInputData] = useState([]);
  const [searchdata, SetsearchData] = useState(
    searchParam.get("search") || "",
    "",
  );
  const [searchUserTextDebounce, setSearchUserTextDebounce] = useState("");
  const [initCategoryFilter] = useState(searchParam.get("category") || "", "");
  const [accountNameValue, setAccountNameValue] = useState("");

  const [selectedValue, setSelectedValue] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [pageSize, setPageSize] = useState(
    searchParam.get("pagesize") || dropdownOptions[0],
  );
  const [currentPage, setCurrentPage] = useState(
    searchParam.get("pageno") || GlobalConfiguration.lengthCheckOne,
  );

  const services = useSelector((state) => state.refreshToken.services);
  const { markerData } = useSelector((s) => s.multiEntitySwitcherSlice);

  const FREQUENCY_MAP = {
    "Once": "once",
    "Daily": "daily",
    "Weekly": "weekly",
    "Fortnightly": "fortnightly",
    "Monthly": "monthly",
    "Quarterly": "quarterly",
    "Half yearly": "half_yearly",
    "Yearly": "yearly",
  };

  const handleFrequencyMethod = (uiValue) => {
    const apiValue = FREQUENCY_MAP[uiValue] || uiValue.toLowerCase();
    handleSubmit("frequency", apiValue);
    setFrequencyMethodfilter(apiValue);
  };

  const handlePaymentMethod = (selectedSettlement) => {
    setIsPaymentMethod(selectedSettlement);
  };

  const handleConfidentialMethod = (selectedSettlement) => {
    setConfidentialMethodFilter(selectedSettlement);
  };

  const formatDate = (date) => {
    return format(new Date(date), "dd MMM, yyyy");
  };

  const handlePagination = (page) => {
    handleSubmit("pageno", page);
    setCurrentPage(page);
  };

  const handleSelect = (value) => {
    if (selectedValue === value) return;
    handleSubmit("pagesize", value);
    setSelectedValue(value);
    setPageSize(value);
    setAccumulatedData([]);
    setCurrentPage(GlobalConfiguration.lengthCheckOne);
    toggleDropdown();
  };

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const handleAction = async () => {
    try {
      setLoading(true);

      let queryParams1 = {
        page_no: currentPage,
        page_item_count: pageSize,
      };

      const addParamsBasedOnSelection = () => {
        if (FrequencyMethodfilter !== "") {
          queryParams1.frequency = FrequencyMethodfilter;
        }
        if (initCategoryFilter !== null) {
          queryParams1.category = initCategoryFilter;
        }
        if (currentStatus && currentStatus !== "all") {
          if (currentStatus === "Require approval") {
            queryParams1.lifecycle_status = "pending";
          } else if (currentStatus === "Discarded") {
            queryParams1.lifecycle_status = "deleted";
          } else {
            queryParams1.lifecycle_status = currentStatus;
          }
        }
        if (isPaymentMethod && isPaymentMethod !== "All") {
          queryParams1.payment_method = isPaymentMethod;
        }
        if (confidentialMethodFilter !== "") {
          queryParams1.confidential_transaction = confidentialMethodFilter;
        }
        if (startDateFilter) {
          queryParams1.transaction_start_date = formatDate(startDateFilter);
        }

        if (endDateFilter) {
          queryParams1.transaction_end_date = formatDate(endDateFilter);
        }
        if (txnAmountFilter !== "") {
          queryParams1.amount = txnAmountFilter;
        }
        if (DestinationAccountName !== "") {
          queryParams1.internal_account_id = DestinationAccountName;
        }

        if (txnPayLoadAccountNameFilter !== "") {
          queryParams1.owner_account_id = txnPayLoadAccountNameFilter;
        }
        if (searchdata !== "") {
          queryParams1.scheduled_name = searchdata;
        }
      };
      addParamsBasedOnSelection();

      const response = await dispatch(scheduledInternalViewAll(queryParams1));
      setMainData(response?.payload);
      setLoading(true);
      const newData = response?.payload?.transactions || [];
      setAccumulatedData(newData);
    } catch (error) {
      setAccumulatedData([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchData = async () => {
    setLoadingData(true);

    let response;
    let data = [];

    try {
      switch (active) {
        case "Category":
          response = await dispatch(
            getAllCategories({ search_string: searchUserTextDebounce }),
          );
          data =
            response?.payload?.categories?.map((itm) => ({
              id: itm.name,
              Category: itm.name,
              Description: itm?.description || "Not given",
            })) || [];
          break;

        case "Internal account":
          response = await dispatch(
            getAllInternalAccounts({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.internal_accounts?.map((itm) => ({
                id: itm.id,
                Name: itm.name,
                Account_number: itm.bank_acc_no,
                display: itm.name,
                IFSC_code: itm.ifsc_code,
                Contact_number: itm.contact_no,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "search":
          if (searchUserTextDebounce === "") {
            SetsearchData("");
          } else {
            SetsearchData(searchUserTextDebounce);
          }
          setLoading(false);
          break;

        case "Owner account":
          response = await dispatch(
            ownerAccountsViewAll({
              search_string: searchUserTextDebounce,
              page_no: 1,
              page_size: 5,
            }),
          );
          if (response?.payload?.status) {
            data =
              response.payload.owner_accounts?.map((itm) => ({
                id: itm.id,
                Account_number: itm.bank_acc_no,
                display: itm.bank_acc_no,
                Name: itm.name,
                IFSC_code: itm.ifsc_code,
                Email_ID: itm.email_id,
              })) || [];
          }
          break;
        case "Search":
          SetsearchData(searchUserTextDebounce);
          setLoadingData(false);

          break;

        default:
          data = [];
          break;
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      data = [];
    } finally {
      setInputData([...data]);
      setLoadingData(false);
    }
  };

  const popupType = () => {
    if (props?.txnHistorytype === "Schedule_Internal_Txn" && !props?.isConf) {
      return "history";
    }
    if (props?.typepop === "scheduleInternalAcc" && !props?.isConf) {
      return "associate";
    }
    if (props?.txnHistorytype === "Schedule_Internal_Txn" && props?.isConf) {
      return "confidential";
    }
  };

  const statuses = [
    "approved",
    "Require approval",
    "pending",
    "rejected",
    "Discarded",
  ];

  const filteredStatuses = statuses.filter((status) => {
    const hasAdmin = services?.includes("Admin");
    const hasAInternal = services?.includes("IAScheduledTxn");
    const hasCInternal = services?.includes("ICScheduledTxn");
    const internalTxn =
      hasCInternal &&
      !hasAInternal &&
      !hasAdmin &&
      status === "Require approval";

    const ScheduleInternalTxn =
      hasAInternal && !hasCInternal && !hasAdmin && status === "pending";

    if (internalTxn) {
      return false;
    }

    if (ScheduleInternalTxn) {
      return false;
    }

    if (hasAdmin && hasAInternal && hasCInternal) {
      return true;
    }

    return true;
  });

  const updateIsFilterApplied = () => {
    setIsFilterApplied(
      isPaymentMethod !== "" ||
        FrequencyMethodfilter !== "" ||
        confidentialMethodFilter !== "" ||
        txnPayLoadFilter !== "" ||
        txnPayLoadDesitinationNameFilter !== "" ||
        searchdata !== "" ||
        initCategoryFilter !== "" ||
        startDateFilter ||
        endDateFilter ||
        txnAmountFilter !== "" ||
        DestinationAccountName !== "" ||
        txnPayLoadAccountNameFilter !== "",
    );
  };

  const handleSubmit = (key, value) => {
    if (
      props?.type !== "scheduleInternalAcc" &&
      props?.txnHistorytype !== "scheduleInternalAccApproval" &&
      props?.txnHistorytype !== "Schedule_Internal_Txn" &&
      props?.type !== "scheduleInternalAcc" &&
      popupType() !== "confidential" &&
      popupType() !== "history" &&
      popupType() !== "associate"
    ) {
      handleSearchParams(key, value);
    }
  };
  const hasData =
    accumulatedData?.length > GlobalConfiguration?.lengthCheckZero;

  const isScheduleAccInternalApproval =
    props?.type === "scheduleInternalAcc" &&
    props?.txnHistorytype === "scheduleInternalAccApproval";

  const showClearButton =
    isPaymentMethod?.length ||
    FrequencyMethodfilter?.length ||
    (!(popupType() === "confidential") && confidentialMethodFilter?.length) ||
    (!(popupType() === "confidential") &&
      !(props?.txnHistorytype === "Schedule_Internal_Txn") &&
      txnPayLoadFilter?.length) ||
    startDateFilter?.length ||
    endDateFilter?.length ||
    txnAmountFilter?.length ||
    (!(popupType() === "confidential") &&
      !(props?.txnHistorytype === "Schedule_Internal_Txn") &&
      txnPayLoadDesitinationNameFilter?.length) ||
    (!isScheduleAccInternalApproval && currentStatus?.length) ||
    (!isScheduleAccInternalApproval &&
      popupType() !== "confidential" &&
      !(props?.txnHistorytype === "Schedule_Internal_Txn") &&
      DestinationAccountName?.length) ||
    searchdata?.length ||
    (!(popupType() === "confidential") &&
      !(props?.txnHistorytype === "Schedule_Internal_Txn") &&
      txnPayLoadAccountNameFilter?.length) ||
    startDate ||
    endDate;

  const isAmountFieldDisabled =
    loading ||
    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
      props?.txnPayLoad?.amount);

  const handleClearAll = () => {
    handleClearSearchParam();
    SetsearchData("");

    props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      setIsPaymentMethod("");

    setFrequencyMethodfilter("");

    if (
      props?.txnHistorytype !== "Schedule_Internal_Txn" &&
      props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      props?.type !== "scheduleInternalAcc" &&
      !props?.isConf
    ) {
      setTxnPayLoadFilter("");
      setTxnPayLoad((prev) => ({ ...prev, ownerbankAccountNo: "" }));
      setTxnPayLoadAccountNameFilter("");
      setTxnPayLoadDestinationNameFilter("");
      setTxnPayLoad((prev) => ({ ...prev, bankAccountNo: "" }));
      setDestinationAccountName("");
    }

    if (isScheduleAccInternalApproval) {
      setTxnPayLoadAccountNameFilter("");
    }
    setStartDate(null);
    setStartDateFilter("");
    setEndDate(null);
    setEndDateFilter("");

    props?.txnHistorytype !== "internalScheduleCreateTxn" &&
      setTxnAmountFilter("");

    setTxnPayLoad((prev) => ({ ...prev, amount: "" }));

    !props?.isConf && setConfidentialMethodFilter("");

    if (props.type !== "scheduleInternalAcc") {
      setCurrentStatus("");
    }
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      const isInsideSearch =
        searchBarContainer.current &&
        searchBarContainer.current.contains(e.target);
      const isInsideToggle =
        searchBarRef.current && searchBarRef.current.contains(e.target);
      const isInsideClear = ctaRef.current && ctaRef.current.contains(e.target);

      if (
        showSearchBar &&
        !isInsideSearch &&
        !isInsideToggle &&
        !isInsideClear
      ) {
        setShowSearchBar(false);
        setShowInnerSearchBar(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [showSearchBar]);

  useEffect(() => {
    if (scrollRef) {
      if (scrollRef?.current?.scrollWidth > scrollRef?.current?.clientWidth) {
        setHideCaroursal(true);
      } else {
        setHideCaroursal(false);
      }
    }
  }, [
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    startDateFilter,
    DestinationAccountName,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
  ]);

  useEffect(() => {
    if (active?.length) {
      fetchData();
    }
  }, [active]);

  useEffect(() => {
    dispatch(enableSwitcher());
    return () => {
      dispatch(disableSwitcher());
    };
  }, []);

  useEffect(() => {
    handleAction();
  }, [
    markerData,
    currentPage,
    pageSize,
    isPaymentMethod,
    txnPayLoadDesitinationNameFilter,
    txnPayLoadAccountNameFilter,
    currentStatus,
    startDateFilter,
    DestinationAccountName,
    FrequencyMethodfilter,
    endDateFilter,
    confidentialMethodFilter,
    txnAmountFilter,
    searchdata,
    initCategoryFilter,
  ]);

  useEffect(() => {
    updateIsFilterApplied();
  }, [
    FrequencyMethodfilter,
    isPaymentMethod,
    confidentialMethodFilter,
    txnPayLoadFilter,
    txnPayLoadDesitinationNameFilter,
    initCategoryFilter,
    startDateFilter,
    endDateFilter,
    txnAmountFilter,
    searchdata,
    DestinationAccountName,
    txnPayLoadAccountNameFilter,
  ]);

  return (
    <div
      className={`overflow-y-hidden Qsmd:overflow-auto flex flex-col bg-primary-bg ${props?.type === "scheduleInternalAcc" || props?.txnHistorytype === "Schedule_Internal_Txn" || props?.txnHistorytype === "internalScheduleCreateTxn" ? "h-full" : "h-full-height"}`}
    >
      <div
        className={` bg-primary-nav relative z-z-index-overlay ${
          isScheduleAccInternalApproval ||
          props?.txnHistorytype === "Schedule_Internal_Txn" ||
          props?.txnHistorytype === "internalScheduleCreateTxn" ||
          props?.txnHistorytype === ""
            ? "hidden"
            : "Qsmd:h-navbar-breadcrumb-height "
        }`}
      ></div>
      <div className="z-z-index-overlay">
        <TopNavComponent
          filteredSearchProps={{
            setShowInnerSearchBar: setShowInnerSearchBar,
            showSearchBar: showSearchBar,
            isSearchDisabled: loading,
            onSearchInput: (val) => {
              setSearchUserTextDebounce(val);
            },
            searchText: searchUserTextDebounce,
            searchPlaceholder: "Search schedule internal transaction",
            filterPlaceholder: "Schedule name",
            filterItems: [
              {
                name: "Search",
                isMulti: false,
                value: searchdata,
                setValue: (val) => {
                  handleSubmit("search", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  SetsearchData(val);
                },
                isDropdown: false,
                isDisabled: loading,
              },
              {
                name: "Internal account",
                short_name: "Internal. Acc",
                isMulti: false,
                value: props?.internal_account_name
                  ? props?.internal_account_name
                  : DestinationAccountName,
                displayValue:
                  props?.txnHistorytype === "Schedule_Internal_Txn" &&
                  props?.isConf
                    ? standardAccountNumberFormat(
                        txnPayLoadDesitinationNameFilter,
                        true,
                      )
                    : props?.txnHistorytype === "internalScheduleCreateTxn"
                      ? standardAccountNumberFormat(
                          props?.txnPayLoad?.bankAccountNo,
                          true,
                        )
                      : accountNameValue?.toLowerCase() ||
                        accountNumber?.toLowerCase(),
                setValue: (val) => {
                  handleSubmit("internalAcc", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setDestinationAccountName(val);
                },
                setDisplayValue: (val) => {
                  setAccountName(val);
                  setAccountNameValue(val);
                },
                isDropdown: true,
                valueType: "string",
                isDisabled:
                  props.type === "scheduleInternalAcc" ||
                  props?.txnHistorytype === "internalScheduleCreateTxn"
                    ? true
                    : loading
                      ? true
                      : popupType() === "confidential" ||
                        popupType() === "history" ||
                        popupType() === "associate",
              },
              {
                name: "Owner account",
                short_name: "Src. Acc",
                isMulti: false,
                value: txnPayLoadAccountNameFilter,
                displayValue: standardAccountNumberFormat(accountNumber, true),
                setValue: (val) => {
                  handleSubmit("sourceAcc", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnPayLoadAccountNameFilter(val);
                },
                setDisplayValue: setAccountNumber,
                valueType: "string",
                isDropdown: true,
                isDisabled:
                  loading ||
                  (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                    props?.txnPayLoad?.ownerId)
                    ? true
                    : props?.txnHistorytype === "Schedule_Internal_Txn",
              },
              {
                name: "Amount",
                short_name: "Amt - INR",
                isMulti: false,
                value: txnAmountFilter,
                setValue: (val) => {
                  if (isAmountFieldDisabled) return;
                  handleSubmit("amount", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setTxnAmountFilter(val);
                },
                displayValue: FormatAmount({
                  price: txnAmountFilter,
                }),
                isDropdown: false,
                isDisabled: isAmountFieldDisabled,
                valueType: "number",
              },
            ],
            filters: [
              {
                name: "Approval status",
                filterType: "dropdown",
                variant: "single",
                value: currentStatus,
                options: filteredStatuses.map((status) => status),
                dropdownPlaceHolder:
                  currentStatus === "deleted"
                    ? "Discard"
                    : currentStatus === "rejected"
                      ? "Rejected"
                      : "Select status",
                isDisabled:
                  props?.type === "scheduleInternalAcc" ? true : false,
                statusPop: true,
                handleChange: (val) => {
                  handleSubmit("lifecycle", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setCurrentStatus(val);
                },
              },
              {
                name: "Schedule start date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: startDateFilter,
                startDate: startDate,
                handleChange: (value) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  setStartDate(value);
                  handleSubmit("startDate", value);
                  setStartDateFilter(value);

                  if (endDate && new Date(value) > new Date(endDate)) {
                    setEndDate("");
                    setEndDateFilter("");
                    handleSubmit("endDate", "");
                  }
                },
                maxDate: null,
              },
              {
                name: "Schedule end date",
                filterType: "calender",
                variant: "single",
                size: "small",
                value: endDateFilter,
                startDate: endDate,
                handleChange: (value) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);

                  setEndDate(value);
                  handleSubmit("endDate", value);
                  setEndDateFilter(value);

                  if (startDate && new Date(value) < new Date(startDate)) {
                    setStartDate("");
                    handleSubmit("startDate", "");
                    setStartDateFilter("");
                  }
                },
                minDate: startDateFilter || new Date(),
                maxDate: null,
              },
              {
                name: "Payment method",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["NEFT", "RTGS"],
                searchPlaceholder: "Search",
                dropdownType: "PaymentMethod",
                dropdownPlaceHolder: "Select type",
                value: isPaymentMethod,
                isDisabled:
                  props?.txnHistorytype === "internalScheduleCreateTxn" &&
                  duplicateFilters?.payment_method,
                handleChange: (val) => {
                  handleSubmit("paymentmethod", val);
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handlePaymentMethod(val);
                },
              },
              services?.includes("VConfidentialTxn") && {
                name: "Show/hide confidential transactions",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: ["Show only confidential", "Hide confidential"],
                searchPlaceholder: "Search",
                isDisabled:
                  (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                    duplicateFilters?.confidential_transaction ===
                      "Show only confidential") ||
                  popupType() === "confidential",
                dropdownPlaceHolder: "Default (all transactions)",
                value: confidentialMethodFilter,
                handleChange: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleSubmit("confidential", val);
                  handleConfidentialMethod(val);
                },
              },
              {
                name: "Frequency",
                filterType: "dropdown",
                variant: "single",
                isSearch: false,
                options: [
                  "Once",
                  "Daily",
                  "Weekly",
                  "Fortnightly",
                  "Monthly",
                  "Quarterly",
                  "Half yearly",
                  "Yearly",
                ],
                searchPlaceholder: "Search",
                dropdownPlaceHolder: "Select frequency",
                value:
                  Object.keys(FREQUENCY_MAP).find(
                    (key) => FREQUENCY_MAP[key] === FrequencyMethodfilter,
                  ) || FrequencyMethodfilter,
                isDisable: false,
                handleChange: (val) => {
                  setCurrentPage(GlobalConfiguration.lengthCheckOne);
                  handleFrequencyMethod(val);
                },
              },
            ],

            isFilterClearAllDisabled:
              props?.txnHistorytype === "internalScheduleCreateTxn" &&
              duplicateFilters?.payment_method
                ? !(
                    FrequencyMethodfilter?.length ||
                    startDateFilter ||
                    (props?.txnHistorytype === "internalScheduleCreateTxn" &&
                      duplicateFilters?.confidential_transaction !==
                        "Show only confidential" &&
                      confidentialMethodFilter) ||
                    endDateFilter ||
                    (props?.type !== "scheduleInternalAcc" &&
                      currentStatus?.length)
                  )
                : !(
                    isPaymentMethod?.length ||
                    FrequencyMethodfilter?.length ||
                    (popupType() !== "confidential" &&
                      confidentialMethodFilter?.length) ||
                    startDateFilter ||
                    endDateFilter ||
                    (props?.type !== "scheduleInternalAcc" &&
                      currentStatus?.length) ||
                    loading
                  ),

            isSearchClearAllDisabled:
              props?.txnHistorytype === "internalScheduleCreateTxn" &&
              props?.txnPayLoad?.amount
                ? !(initCategoryFilter?.length || searchdata?.length)
                : props?.txnHistorytype === "Schedule_Internal_Txn"
                  ? !(txnAmountFilter?.length || searchdata?.length)
                  : !(
                      initCategoryFilter?.length ||
                      (popupType() !== "history" &&
                        popupType() !== "confidential" &&
                        popupType() !== "associate" &&
                        props?.type !== "scheduleInternalAcc" &&
                        DestinationAccountName?.length) ||
                      (popupType() !== "history" &&
                        popupType() !== "confidential" &&
                        popupType() !== "associate" &&
                        props?.type !== "scheduleInternalAcc" &&
                        beneAccountId?.length) ||
                      searchdata?.length ||
                      txnAmountFilter?.length ||
                      txnPayLoadAccountNameFilter?.length ||
                      loading
                    ),

            inputData: inputData,
            active: active,
            setActive: setActive,
            loading: loading,
            loadingData: loadingData,
            setLoading: setLoadingData,
            isShowFilter: true,
          }}
          BottomSubText={
            "Below are the schedules’ details. Approved schedules will generate transactions according to the specified frequency."
          }
        />
      </div>

      {showInnerSearchBar && (
        <div className="absolute bg-PopUp-BackDrop bg-opacity-light-opacity w-full h-full z-z-index-header"></div>
      )}

      <div
        ref={scrollRef}
        className={`flex flex-col relative flex-1 items-center  
          h-height-full overflow-x-hidden overflow-y-auto ${!accumulatedData?.length && "justify-center"} ${props?.type === "scheduleInternalAcc" || props?.txnHistorytype === "internalScheduleCreateTxn" ? "" : ""}`}
        style={{
          paddingTop:
            !showSearchBar &&
            isFilterApplied &&
            !accumulatedData.length &&
            (props?.txnHistorytype === "Schedule_Internal_Txn" ||
              props?.type === "scheduleInternalAcc" ||
              props?.txnHistorytype === "internalScheduleCreateTxn") &&
            !hideCarousal
              ? "var(--padding-md)"
              : isFilterApplied &&
                  !accumulatedData.length &&
                  (props?.txnHistorytype === "Schedule_Internal_Txn" ||
                    props?.type === "scheduleInternalAcc" ||
                    props?.txnHistorytype === "internalScheduleCreateTxn")
                ? "var(--padding-md)"
                : "",
          scrollPaddingTop: "var(--padding-md)",
          scrollPaddingBottom: "var(--padding-md)",
        }}
      >
        <div className="flex flex-col items-center w-full z-z-index-base flex-1">
          {loading ? (
            <div className="loader-container m-auto flex justify-center items-center w-width-full h-height-full">
              <Loader />
            </div>
          ) : hasData ? (
            <div className="flex flex-col min-h-height-base flex-1 w-width-full h-full-height">
              <ScheduleInternalTransactionViewAllCard
                openTxnHistory={props.openTxnHistory}
                setLoading={setLoading}
                data={accumulatedData}
                filterRef={scrollRef}
                currentStatus={currentStatus}
                txnHistorytype={props?.txnHistorytype}
                typepop={props?.type}
                onClose={props?.onClose}
              />
            </div>
          ) : (
            <div
              className="h-height-full opacity-dark-opacity flex flex-col items-center justify-center Qmd:m-auto mx-auto my-margin-xl gap-gap-sm"
              style={{
                opacity:
                  isSidebarOpen || showInnerSearchBar
                    ? "var(--light-opacity)"
                    : "var(--base-opacity)",
              }}
            >
              <img
                src={ICONS?.NO_DATA_FOUND}
                alt="No data found"
                className="w-graphic-width-md h-graphic-rectangle-height-md"
              />

              <p className="text-font-sm text-text-primary">No data found.</p>

              {showClearButton && (
                <PrimaryButton
                  enabledBgColor="var(--primary-act)"
                  btnText="Clear parameters"
                  enabledTextColor="var(--text-primary)"
                  handleFunction={handleClearAll}
                  buttonRef={ctaRef}
                  hoverOption="white"
                />
              )}
            </div>
          )}
        </div>
      </div>
      {!loading &&
        accumulatedData?.length > GlobalConfiguration?.lengthCheckZero && (
          <div
            className={`${
              props?.txnHistorytype === "Schedule_Internal_Txn" ||
              props?.type === "scheduleInternalAcc"
                ? "w-width-full rounded-none Qsmd:rounded-b-border-radius-md"
                : props?.txnHistorytype === "internalScheduleCreateTxn"
                  ? "w-width-full rounded-none Qsmd:rounded-b-border-radius-md"
                  : `w-width-full  rounded-none z-z-index-base ${isSidebarOpen && "pointer-events-none"}`
            }`}
          >
            <PaginationComponent
              handleSelect={handleSelect}
              selectedValue={selectedValue}
              data={mainData}
              pageSize={pageSize}
              dropdownOptions={dropdownOptions}
              handlePagination={handlePagination}
              currentPage={currentPage}
              payload={props?.payload}
              setIsOpen={setIsOpen}
              type={
                props?.type === "scheduleInternalAcc"
                  ? "scheduleInternalAcc"
                  : ""
              }
            />
          </div>
        )}
    </div>
  );
};

export default ScheduleInternalTransactionViewSchedules;
